import { Badge, Text } from "@chakra-ui/react"
import { Position, PositionSide } from "@perp/sdk-curie"
import { Stats } from "component/Stats"

import { usePositionWithRatioStrings } from "../../../position/hook/usePositionWithRatioStrings"

interface Props {
    position: Position
    ratio?: number
}

const DECIMAL_SIX_STR = "0.000000"

export function MakerPositionSize({ position, ratio }: Props) {
    const { side } = position
    const { positionSizeStr, notionalValueStr } = usePositionWithRatioStrings(position, ratio)
    const baseSymbol = position?.market.baseSymbol || ""
    const badgeColor = side === PositionSide.LONG ? "green" : "red"

    return (
        <>
            <Stats
                size="xl"
                label="Impermanent Position"
                numberComponent={
                    <Text>
                        {positionSizeStr} {baseSymbol}
                        <Badge size="xs" ml={2} variant="subtle" colorScheme={badgeColor}>
                            {side}
                        </Badge>
                    </Text>
                }
                helper={notionalValueStr.startsWith(DECIMAL_SIX_STR) ? "≈$0" : "$" + notionalValueStr}
            />
        </>
    )
}
